import * as React from 'react';
import * as cx from 'classnames';

import { CoordinationCardStatuses } from 'data/models/CoordinationCardStatuses';

export function CCardStatusClassname(statusId : CoordinationCardStatuses) {
    // NOTE: Matches the conventions in @ccard-statuses variable in variables.less and
    // #ccard-status-colors.apply-to(...) mixin in mixins.less. Keep in sync.
    return `status-${CoordinationCardStatuses[statusId]?.toLowerCase() ?? ''}`;
}

export function CCardStatusIndicator({ statusId } : { statusId : CoordinationCardStatuses }) {
    return (
        <span className={cx('ccardstatusindicator', CCardStatusClassname(statusId))} />
    );
}



// WEBPACK FOOTER //
// ./apps/portcall/ccardstatusindicator/view.tsx